import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import CustomTable from '../../components/Shared/CustomTable'
import PageHeader from '../../components/Shared/PageHeader'

export default function ViewEmployeePage () {
  const location = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const employee = location?.state?.employee || null

  const columns = [
    { field: 'first_name', header: t('first_name') },
    { field: 'last_name', header: t('last_name') },
    { field: 'national_id', header: t('national_id') },
    { field: 'contact_number', header: t('contact_number') },
    { field: 'email', header: t('email') },
    { field: 'department_id', header: t('department') },
    { field: 'job_title', header: t('job_title') },
    { field: 'salary', header: t('salary') },
    { field: 'bank_account_number', header: t('bank_account_number') },
    { field: 'hire_date', header: t('hire_date') }
  ]

  if (!employee) {
    return (
      <div>
        <PageHeader title={t('employee_details')} onBack={() => navigate(-1)} />
        <p className='mt-4'>{t('No_employee_selected')}</p>
       
      </div>
    )
  }

  const data = [employee]

  return (
    <div>
      <PageHeader title={t('employee_details')} onBack={() => navigate(-1)} />
      <CustomTable data={data} columns={columns} rows={1} />
    </div>
  )
}
